import React from "react";
import { Link } from "react-router-dom";
import { resetConsent } from "../../utils/consent";
import "../../styles/Footer.css";

// There was no footer at all before this. It briefly carried an oversized
// wordmark bled to the edges; that was lifted too directly from somewhere else
// to be worth keeping. The dark band stays because it closes the page, not
// because of what was in it.

const GROUPS = [
    {
        heading: "Advertise",
        links: [
            { to: "/devices", label: "Explore locations" },
            { to: "/register/customer", label: "Create an account" },
            { to: "/about", label: "How it works" },
        ],
    },
    {
        // "Host a screen", not "List a screen". A business owner with an empty
        // wall does not yet think of themselves as having something to list.
        heading: "Host a screen",
        links: [
            { to: "/waitlist", label: "Become a host" },
            { to: "/register/vendor", label: "Host sign-up" },
        ],
    },
    {
        heading: "Company",
        links: [
            { to: "/about", label: "About" },
            { to: "/login", label: "Sign in" },
        ],
    },
];

export default function Footer() {
    return (
        <footer className="ft">
            <div className="ft__inner">
                <div className="ft__cols">
                    <div className="ft__pitch">
                        <h2>Screens in the real world, booked by the day.</h2>
                        <p>
                            Advertise on screens inside local businesses — or host one
                            in yours and earn from the space you already have.
                        </p>
                        <Link to="/devices" className="wb-btn wb-btn--primary">
                            Explore locations
                        </Link>
                    </div>

                    {GROUPS.map((group) => (
                        <nav className="ft__group" key={group.heading} aria-label={group.heading}>
                            <h3>{group.heading}</h3>
                            <ul>
                                {group.links.map((link) => (
                                    <li key={link.label}>
                                        <Link to={link.to}>{link.label}</Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    ))}
                </div>

                <div className="ft__legal">
                    <span>© {new Date().getFullYear()} WallBurst</span>
                    <span className="ft__legal-links">
                        <Link to="/terms">Terms</Link>
                        <Link to="/privacy">Privacy</Link>
                        {/* Required to be as reachable as giving consent was.
                            Clears the stored decision, which brings the banner
                            back rather than opening a second, different UI. */}
                        <button
                            type="button"
                            className="ft__legal-btn"
                            onClick={resetConsent}
                        >
                            Cookie settings
                        </button>
                    </span>
                </div>
            </div>
        </footer>
    );
}
